<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Device from './Device'
import Sensor from './Sensor'
import Layout from '@/router/layouts/main'
import FuelRawHistory from './FuelRawHistory'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'QC Device',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Device,
    Sensor,
    FuelRawHistory
  },
  data() {
    return {
      region: 'SG',
    }
  },
  handleSubmit() {
    this.$nextTick(() => {
      this.$bvModal.hide('modal-set')
    })
  },
  computed: {
    title() {
      return this.$t('qcdevice.dataMaster')
    },
  },
  created() {
    this.initialDeviceData = JSON.parse(localStorage.getItem('device'))
    if (this.initialDeviceData?.serverRegion) {
      this.region = this.initialDeviceData.serverRegion
    }
  },
  methods: {
    onTabChange(newTabIndex) {
      if (newTabIndex === 0) {
        this.$refs.deviceComponent.getSensorData();
      }
    }
  },
  mixins: [Helper],
}
</script>

<template>
  <Layout>
    <div class="mb-4">
      <b-row>
        <b-col cols="4">
          <b-form-select
            class="form-select form-select-md __limit--dropdown w-25"
            v-model="region"
          >
            <b-form-select-option value="SG">Singapura</b-form-select-option>
            <b-form-select-option value="ID">Indonesia</b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
    </div>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs @activate-tab="onTabChange" content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('qcdevice.dataMaster') }}</span>
            </template>
            <Device ref="deviceComponent" :region="region" />
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Pengaturan Sensor</span>
            </template>
            <Sensor :region="region" />
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Fuel Raw History</span>
            </template>
            <FuelRawHistory :region="region" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
